import React from 'react';
import styled from 'react-emotion';

import BaseIconButton from '@material-ui/core/IconButton';

import { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export const IconButton = styled(BaseIconButton)`
  border-radius: 4px;
  margin-left: 8px;
  padding: 0;
  width: 24px;
  height: 24px;
  border: 1px solid ${colors.grey8};
`;

export const Icon = styled(
  ({ IconType, ...props }) => <IconType {...props} />,
  {
    shouldForwardProp: (prop) => prop !== 'fontSize',
  }
)`
  font-size: ${(props) => props.fontSize};
`;
